import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Overview from '../screens/Overview';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import Subscription from '../screens/Subscription';

/**
 * Routes for demo-mode visitors: read-only Overview + Subscription only.
 * Everything else (Discover, Balance, Account, Detail, Control, ProfitCalcs)
 * is intentionally omitted — unknown paths fall through to "/*" = Overview.
 *
 * Pulled out of `src/index.tsx` so that file has no demo-specific routing.
 */
const DemoRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/*" element={<Overview />} />
      <Route path="/sub" element={<Subscription />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  </BrowserRouter>
);

export default DemoRoutes;
